import { REVIEW_RESPONSE_PREFERRED_STYLE } from '../actions/types';

const INITIAL_STATE = [];

export default function reviewResponsePreferredStyleReducer(
	state = INITIAL_STATE,
	action
) {
	switch (action.type) {
		case REVIEW_RESPONSE_PREFERRED_STYLE:
			return action.payload;
		default:
			return state;
	}
}
